/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2020-01-17 15:03:45
 *
 *******************************************************/
// @flow

import React, { Component } from 'react';
import { Button, DisplayText, Stack } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import empty from 'src/assets/images/filter-tree/empty-option.png';
import { routes } from 'src/routes';
import history from 'src/routes/history';

import { enterSABFullscreen } from 'src/integrations/shopify-app-bridge/fullscreen';

type Props = WithI18nProps;
// DONE
class NoRules extends Component<Props> {
  render() {
    const { i18n, panelID } = this.props;
    return (
      <div className="BC-EmptyRules__MerchandisingV2">
        <Stack vertical>
          <img src={empty} alt="Empty" />
          <div>
            <DisplayText size="small">
              {i18n.translate('AdminHTML.MerchandisingV2.NoRules.title')}
            </DisplayText>
            <p style={{ marginTop: '0.5rem', color: '#6D7175' }}>
              {i18n.translate(
                `AdminHTML.MerchandisingV2.NoRules.${
                  panelID === 'search' ? 'paragraph' : 'paragraphCollection'
                }`
              )}
            </p>
          </div>
          <Button primary onClick={() => this.openRulePage(panelID)}>
            {i18n.translate('AdminHTML.MerchandisingV2.Merchandising.newRule')}
          </Button>
        </Stack>
      </div>
    );
  }
  openRulePage = ruleType => {
    history.push(routes.merchandising.new(ruleType));
    enterSABFullscreen();
  };
}

export default withI18n()(NoRules);
